import React, { Component } from 'react';
import ModalBox from '../../components/ModalBox';

import './index.scss';

export default class AccessDeniedModal extends Component {

  render() {

    const {
      onClose,
      modalActive,
    } = this.props

    return (

      <ModalBox
        modalActive={modalActive}
        modalLabel='Acesso não liberado'
        onChange={() => onClose()}
      >
        <div data-testid="access-denied" className="col s12 m4 offset-m4 access-denied-container">
          <div className="main-container">
            <i className="material-icons">block</i>
            <p className="first-paragraph">Acesso não liberado</p>
            <p className="flow-text">O App Prestador não está liberado para o seu usuário. Para liberação do acesso é necessário o aceite do termo “Li e Concordo” no Portal do Credenciado SulAmérica Odonto</p>
          </div>
        </div>
      </ModalBox>

    )

  }
}